/** The app-wide notification store, read by the toast stack and the bell (services/notify). */
import { useSyncExternalStore } from "react";
import { getNotificationSnapshot, subscribeNotifications } from "../services/notify";
import type { NotificationSnapshot } from "../services/notify";

export const useNotifications = (): NotificationSnapshot =>
  useSyncExternalStore(subscribeNotifications, getNotificationSnapshot, getNotificationSnapshot);
